export default __webpack_public_path__ + "img/olivertree_theater-01.9111ff7afa99a6d633798ecb920ab438.png";